import React from 'react';
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Stack,
    Typography,
} from '@mui/material';
import AuthPanel from '../auth/AuthPanel';
import { useAuth } from '../../context/AuthContext';

function BankruptcyStartDialog({ open, onClose, isAuthenticated, initialAuthTab = 'register' }) {
    const { establishSession } = useAuth();

    const initialMode = initialAuthTab === 'login' ? 'login' : 'signup';

    const renderAuthenticatedState = () => (
        <Stack spacing={2}>
            <Typography sx={{ color: '#667085', lineHeight: 1.7 }}>
                Вы уже авторизованы. Новая регистрация здесь не нужна: переходите в рабочий кабинет и создавайте проект уже внутри системы.
            </Typography>
            <Button
                variant="contained"
                onClick={() => {
                    window.location.href = '/app/';
                }}
                sx={{ alignSelf: 'flex-start', textTransform: 'none', fontWeight: 700 }}
            >
                Перейти в кабинет
            </Button>
        </Stack>
    );

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle sx={{ pb: 1 }}>
                {isAuthenticated ? 'Аккаунт уже активен' : 'Начать работу'}
            </DialogTitle>
            <DialogContent sx={{ pb: 2 }}>
                {isAuthenticated ? renderAuthenticatedState() : (
                    <Box sx={{ pt: 1 }}>
                        <AuthPanel
                            initialMode={initialMode}
                            showRecoveryTab={false}
                            onAuthenticated={() => {
                                establishSession();
                                window.location.href = '/app/';
                            }}
                            copy={{
                                signupDescription: 'Для регистрации заполните все поля формы. На email будут приходить системные уведомления, поэтому важно, чтобы он был актуальный.',
                                loginTitle: 'Вход',
                                loginDescription: 'Войдите в существующий аккаунт.',
                                recoveryTitle: 'Восстановление пароля',
                                recoveryDescription: 'Укажите email, и мы отправим письмо для восстановления пароля.',
                                signupSubmitLabel: 'Получить письмо активации',
                                signupSubmitPendingLabel: 'Отправляем...',
                                signupSuccessAlert: 'Письмо для активации отправлено, его доставка может занять до 2 минут. Перейдите по ссылке из email и создайте пароль.',
                            }}
                        />
                    </Box>
                )}
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 3 }}>
                <Button onClick={onClose}>
                    Закрыть
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default BankruptcyStartDialog;
